export default __webpack_public_path__ + "static/media/127.341fc7b1.png";